import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Editor from './components/Editor';
import ArticleList from './components/ArticleList';
import Settings from './components/Settings';
import LockScreen from './components/LockScreen';
import PasswordSettings from './components/PasswordSettings';
import { ArticleProvider } from './context/ArticleContext';
import './App.css';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(
    localStorage.getItem('prosomo_auth') === 'authenticated'
  );

  const handleUnlock = () => {
    setIsAuthenticated(true);
  };

  const handleLock = () => {
    setIsAuthenticated(false);
    localStorage.removeItem('prosomo_auth');
  };

  return (
    <ArticleProvider>
      {!isAuthenticated ? (
        <LockScreen onUnlock={handleUnlock} />
      ) : (
        <Router>
          <div className="min-h-screen bg-gray-50">
            <Header onLock={handleLock} />
            <main className="container mx-auto px-4 py-8">
              <Routes>
                <Route path="/" element={<ArticleList />} />
                <Route path="/editor/:id?" element={<Editor />} />
                <Route path="/settings" element={<div className="space-y-6"> <Settings /> <PasswordSettings /> </div>} />
              </Routes>
            </main>
          </div>
        </Router>
      )}
    </ArticleProvider>
  );
}

export default App;